<template>
    <rkm-modal
        :large="notification.large"
        :loading="notification.loading"
        :visible="notification.visible"
        hide-header
        persistent
        hide-legend
    >
        <rkm-row>
            <rkm-col>
                <h5 :class="`text-${notification.color}`">
                    {{ notification.title }}
                </h5>

                <p
                    v-html="notification.message"
                    class="m-0"
                ></p>
            </rkm-col>
        </rkm-row>

        <template v-slot:footer>
            <template v-if="notification.type === 'dialog'">
                <rkm-button
                    :disabled="notification.loading"
                    @click="handleClose(button.CANCEL_OR_NO)"
                >
                    {{ notification.btnCancel || 'Não' }}
                </rkm-button>

                <rkm-button
                    :color="notification.color"
                    :disabled="notification.loading"
                    @click="handleConfirm"
                >
                    {{ notification.btnOk || 'Sim' }}
                </rkm-button>
            </template>

            <template v-else-if="notification.type === 'alert'">
                <rkm-button
                    :color="notification.color"
                    @click="handleClose(button.OK)"
                >
                    {{ notification.btnOk || 'Ok' }}
                </rkm-button>
            </template>
        </template>
    </rkm-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters('notification', {notification: 'getNotification'}),
    },
    data: () => ({
        button: {
            CANCEL_OR_NO: 2,
            OK: 3,
        }
    }),
    methods: {
        ...mapActions('notification', ['setNotification']),
        async handleConfirm() {
            this.setNotification({ loading: true })

            try {
                if (typeof this.notification.confirm === 'function') {
                    await this.notification.confirm()
                }

                this.setNotification({ visible: false })
            }
            catch (error) {
                if (typeof this.notification.onError === 'function') {
                    this.notification.onError(error)
                }
            }
            finally {
                this.setNotification({ loading: false })
            }
        },
        handleClose(buttonClicked) {
            if (buttonClicked === this.button.CANCEL_OR_NO) {

                if (typeof this.notification.cancel === 'function') {
                    this.setNotification({ loading: true })

                    this.notification.cancel()
                        .then(() => {
                            this.setNotification({ visible: false })
                        })
                        .finally(() => this.setNotification({ loading: false }))

                    return
                }
            }
            else if (buttonClicked === this.button.OK) {

                if (typeof this.notification.ok === 'function') {
                    this.setNotification({ loading: true })

                    this.notification.ok()
                        .then(() => {
                            this.setNotification({ visible: false })
                        })
                        .finally(() => this.setNotification({ loading: false }))

                    return
                }
            }

            this.setNotification({ visible: false })
        },
    },
}
</script>